import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import api from '../api';
import { useNotifications } from '../components/NotificationProvider';
import { Avatar, Ic, Spinner } from '../components/ui';
import BotSwitcher from '../components/BotSwitcher';

/* Canlı Sohbet — Telegram modülüyle aynı görsel dil */

const WS_URL = () => (window.location.protocol === 'https:' ? 'wss' : 'ws') + '://' + window.location.host + '/ws';
const mediaUrl = p => '/uploads/' + p;
const TAG_COLORS = ['#6ab3f3', '#56c26a', '#e5a443', '#ef5b5b', '#a695e7', '#f27eb5', '#4fd1c5'];
const NOTE_COLORS = ['#e5a443', '#56c26a', '#6ab3f3', '#ef5b5b', '#a695e7', '#ff9f5a'];
const TAG_PRESETS = ['VIP', 'Sorun', 'Takipte', 'Çözüldü', 'Yeni'];

function listTime(s) {
  if (!s) return '';
  const d = new Date(s), n = new Date();
  if (d.toDateString() === n.toDateString()) return d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  if (n - d < 6 * 86400000) return d.toLocaleDateString('tr-TR', { weekday: 'short' });
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' });
}
const hhmm = s => new Date(s).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
function dayLabel(s) {
  const d = new Date(s), n = new Date();
  if (d.toDateString() === n.toDateString()) return 'Bugün';
  const y = new Date(n); y.setDate(n.getDate() - 1);
  if (d.toDateString() === y.toDateString()) return 'Dün';
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', ...(d.getFullYear() !== n.getFullYear() ? { year: 'numeric' } : {}) });
}
const LS_BOT = 'lc_last_bot';
function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* noop */ } }
const typeLabel = t => ({ photo: 'Fotoğraf', video: 'Video', gif: 'GIF', file: 'Dosya', voice: 'Sesli mesaj', audio: 'Ses', sticker: 'Çıkartma', document: 'Dosya' })[t] || t;

const CSS = `
.lc { display:flex; height:var(--tg-h, calc(100vh - 48px)); background:#0e1621; overflow:hidden; border-radius:var(--tg-radius, 12px); position:relative; }
.lc-list { width:360px; min-width:300px; display:flex; flex-direction:column; background:var(--surface); border-right:1px solid #0a1119; }
.lc-main { flex:1; display:flex; flex-direction:column; min-width:0; position:relative; }
.lc-info { width:340px; flex-shrink:0; background:var(--surface); border-left:1px solid #0a1119; display:flex; flex-direction:column; }
.lc-row { display:flex; align-items:center; gap:12px; padding:7px 10px; margin:0 6px; border-radius:10px; cursor:pointer; transition:background .1s; }
.lc-row:hover { background:var(--hover); }
.lc-row.act { background:var(--active); }
.lc-rail { width:84px; flex-shrink:0; background:#0f1923; border-right:1px solid #0a1119; display:flex; flex-direction:column; align-items:stretch; overflow-y:auto; overflow-x:hidden; padding:6px 0; scrollbar-width:none; }
.lc-rail::-webkit-scrollbar { display:none; }
.lc-rb { position:relative; display:flex; flex-direction:column; align-items:center; gap:5px; padding:8px 4px 7px; margin:1px 5px; border-radius:10px; cursor:pointer; background:none; border:none; color:var(--text3); font:inherit; transition:background .1s, color .1s; -webkit-tap-highlight-color:transparent; }
.lc-rb:hover { background:rgba(255,255,255,.05); color:var(--text2); }
.lc-rb.on { color:#fff; background:rgba(82,136,193,.16); }
.lc-rb.on::before { content:''; position:absolute; left:-5px; top:12px; bottom:12px; width:4px; border-radius:0 4px 4px 0; background:var(--link); }
.lc-rb .nm { font-size:11px; font-weight:600; line-height:1.2; text-align:center; max-width:100%; overflow:hidden; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; word-break:break-word; }
.lc-rb .bdg { position:absolute; top:4px; right:9px; background:var(--accent); color:#fff; font-size:11px; font-weight:700; border-radius:10px; min-width:19px; height:19px; line-height:19px; text-align:center; padding:0 5px; box-shadow:0 0 0 2px #0f1923; }
.lc-rb .av { border-radius:50%; transition:box-shadow .12s; }
.lc-rb.on .av { box-shadow:0 0 0 2px #0f1923, 0 0 0 4px var(--link); }
.lc-bsw { display:none; padding:8px 10px 2px; }
.lc-ib { background:none; border:none; color:var(--text3); cursor:pointer; padding:8px; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0; text-decoration:none !important; }
.lc-ib:hover { background:rgba(255,255,255,.07); color:#b6c2cd; }
.lc-ib.on { color:var(--link); }
.lc-pill { background:rgba(30,44,58,.9); color:#e8edf2; font-size:13px; font-weight:500; padding:4px 12px; border-radius:14px; }
.lc-mi { display:block; width:100%; text-align:left; padding:9px 14px; border-radius:8px; cursor:pointer; }
.lc-mi:hover { background:rgba(255,255,255,.06); }
.lc-chip { display:inline-flex; align-items:center; gap:4px; font-size:12px; font-weight:600; padding:2px 9px; border-radius:12px; }
.lc-sw { width:20px; height:20px; border-radius:50%; cursor:pointer; border:2px solid transparent; }
.lc-sw.on { border-color:#fff; }
@media (max-width: 1200px) { .lc-info { position:absolute; right:0; top:0; bottom:0; z-index:40; box-shadow:-10px 0 30px rgba(0,0,0,.4); } }
@media (max-width: 1100px) { .lc-list { width:320px; min-width:280px; } }
@media (max-width: 900px) {
  .lc-rail { display:none; }
  .lc-bsw { display:block; }
  .lc-list { width:100%; min-width:0; border-right:none; }
  .lc.has-sel .lc-list { display:none; }
  .lc:not(.has-sel) .lc-main { display:none; }
  .lc-info { width:100%; }
}
`;

export default function Chat() {
  const [bots, setBots] = useState([]);
  const [selectedBot, setSelectedBot] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [convLoading, setConvLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState('');
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [sending, setSending] = useState(false);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState(false);
  const [quickReplies, setQuickReplies] = useState([]);
  const [notes, setNotes] = useState([]);
  const [showQR, setShowQR] = useState(false);
  const [qrSearch, setQrSearch] = useState('');
  const [newNote, setNewNote] = useState('');
  const [noteColor, setNoteColor] = useState(NOTE_COLORS[0]);
  const [newTag, setNewTag] = useState('');
  const [tagColor, setTagColor] = useState(TAG_COLORS[0]);
  const [showQRManager, setShowQRManager] = useState(false);
  const [newQR, setNewQR] = useState({ title: '', content: '', shortcut: '', category: 'genel' });
  const [lightbox, setLightbox] = useState(null);
  const [toast, setToast] = useState(null);
  const [botUnread, setBotUnread] = useState({});

  const listRef = useRef(null);
  const wsRef = useRef(null);
  const wsClosed = useRef(false);
  const fileInputRef = useRef();
  const inputRef = useRef();
  const selUserRef = useRef(null);
  const selBotRef = useRef(null);
  const atBottom = useRef(true);
  const notif = useNotifications() || {};
  const fetchUnread = notif.fetchUnread || (() => {});

  selUserRef.current = selectedUser;
  selBotRef.current = selectedBot;

  useEffect(() => {
    api.get('/bots').then(r => {
      const list = r.data || [];
      setBots(list);
      if (list.length) {
        const last = lsGet(LS_BOT);
        setSelectedBot(list.find(b => String(b.id) === last) || list[0]);
      }
    }).catch(() => {});
    loadQuickReplies();
  }, []);

  /* her botun okunmamış sayısı (bot rayındaki rozetler) — 90 sn'de bir tazelenir, arada websocket ile artar */
  useEffect(() => {
    if (!bots.length) return undefined;
    let dead = false;
    async function loadBotUnread() {
      if (document.hidden) return;
      const res = await Promise.all(bots.slice(0, 40).map(b => api.get(`/chat/conversations/${b.id}`, { params: { filter: 'unread', limit: 100 } })
        .then(r => [b.id, (r.data || []).reduce((s, c) => s + (parseInt(c.unread_count, 10) || 0), 0)]).catch(() => null)));
      if (dead) return;
      setBotUnread(prev => { const n = { ...prev }; res.forEach(x => { if (x) n[x[0]] = x[1]; }); return n; });
    }
    loadBotUnread();
    const t = setInterval(loadBotUnread, 90000);
    return () => { dead = true; clearInterval(t); };
  }, [bots]);

  /* Alt+↑ / Alt+↓ : önceki / sonraki bot */
  const switchRef = useRef(() => {});
  useEffect(() => {
    const k = e => {
      if (!e.altKey || (e.key !== 'ArrowUp' && e.key !== 'ArrowDown')) return;
      e.preventDefault();
      switchRef.current(e.key === 'ArrowDown' ? 1 : -1);
    };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, []);

  useEffect(() => {
    if (!selectedBot) return undefined;
    const t = setTimeout(loadConversations, search ? 300 : 0);
    return () => clearTimeout(t);
  }, [selectedBot, search, filter]);

  useEffect(() => {
    if (selectedUser && selectedBot) { loadMessages(); loadNotes(); }
  }, [selectedUser?.telegram_id, selectedBot?.id]);

  function stickBottom() {
    const el = listRef.current;
    if (el && atBottom.current) el.scrollTop = el.scrollHeight;
  }
  useLayoutEffect(stickBottom, [messages]);
  useEffect(() => {
    const el = listRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(() => stickBottom());
    ro.observe(el);
    if (el.firstChild) ro.observe(el.firstChild);
    return () => ro.disconnect();
  }, [selectedUser?.telegram_id]);

  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(() => setToast(null), 2500);
    return () => clearTimeout(t);
  }, [toast]);

  /* ── websocket (otomatik yeniden bağlanır) ── */
  const onWsRef = useRef(() => {});
  onWsRef.current = (data) => {
    if (data.event !== 'new_message') return;
    const msg = data.message;
    const cur = selUserRef.current;
    const curBot = selBotRef.current;
    if (curBot && msg.bot_id && String(msg.bot_id) !== String(curBot.id)) {
      if (msg.direction === 'in' && !msg.content?.startsWith('/start')) { fetchUnread(); setBotUnread(p => ({ ...p, [msg.bot_id]: (p[msg.bot_id] || 0) + 1 })); }
      return;
    }
    if (cur && cur.telegram_id === msg.telegram_id) {
      setMessages(prev => (prev.some(m => m.id === msg.id) ? prev : [...prev.filter(m => !(m._tmp && msg.direction === 'out' && m.content === msg.content)), msg]));
      if (msg.direction === 'in') api.get(`/chat/${msg.bot_id}/${msg.telegram_id}`).catch(() => {});
    }
    updateConvList(msg);
    if (msg.direction === 'in' && !msg.content?.startsWith('/start') && cur?.telegram_id !== msg.telegram_id) fetchUnread();
  };
  useEffect(() => {
    wsClosed.current = false;
    function connect() {
      try {
        const ws = new WebSocket(WS_URL());
        wsRef.current = ws;
        ws.onmessage = e => { try { onWsRef.current(JSON.parse(e.data)); } catch (x) { /* noop */ } };
        ws.onclose = () => { if (!wsClosed.current) setTimeout(connect, 3000); };
      } catch (e) { /* noop */ }
    }
    connect();
    return () => { wsClosed.current = true; try { wsRef.current?.close(); } catch (e) { /* noop */ } };
  }, []);

  function updateConvList(msg) {
    setConversations(prev => {
      const isActive = selUserRef.current?.telegram_id === msg.telegram_id;
      const ex = prev.find(c => c.telegram_id === msg.telegram_id);
      const upd = {
        ...(ex || {}),
        telegram_id: msg.telegram_id,
        full_name: msg.full_name || ex?.full_name || 'Kullanıcı',
        last_message: msg.content, last_direction: msg.direction, last_type: msg.type, last_time: msg.created_at,
        unread_count: msg.direction === 'in' ? (isActive ? 0 : (parseInt(ex?.unread_count || 0, 10) + 1)) : (ex?.unread_count || 0),
      };
      return [upd, ...prev.filter(c => c.telegram_id !== msg.telegram_id)];
    });
  }

  /* ── data ── */
  async function loadConversations() {
    setConvLoading(true);
    try {
      const res = await api.get(`/chat/conversations/${selectedBot.id}`, { params: { ...(search ? { search } : {}), ...(filter === 'unread' ? { filter: 'unread' } : {}), limit: 100 } });
      setConversations(res.data || []);
    } catch (e) { /* noop */ }
    setConvLoading(false);
  }
  async function loadMessages() {
    setLoading(true);
    atBottom.current = true;
    try {
      const res = await api.get(`/chat/${selectedBot.id}/${selectedUser.telegram_id}`);
      setMessages(res.data || []);
      setConversations(prev => prev.map(c => (c.telegram_id === selectedUser.telegram_id ? { ...c, unread_count: 0 } : c)));
      fetchUnread();
    } catch (e) { /* noop */ }
    setLoading(false);
  }
  async function loadQuickReplies() { try { const r = await api.get('/chat/quick-replies/list'); setQuickReplies(r.data || []); } catch (e) { /* noop */ } }
  async function loadNotes() { try { const r = await api.get(`/chat/notes/${selectedBot.id}/${selectedUser.telegram_id}`); setNotes(r.data || []); } catch (e) { setNotes([]); } }

  /* ── actions ── */
  async function sendMessage() {
    const text = newMsg.trim();
    if (!text || !selectedUser || sending) return;
    setSending(true);
    const tmp = { id: 'tmp' + Date.now(), _tmp: true, direction: 'out', type: 'text', content: text, created_at: new Date().toISOString() };
    atBottom.current = true;
    setMessages(p => [...p, tmp]);
    setNewMsg('');
    if (inputRef.current) inputRef.current.style.height = '22px';
    try {
      await api.post(`/chat/${selectedBot.id}/${selectedUser.telegram_id}`, { message: text });
      setTimeout(() => setMessages(p => p.map(m => (m.id === tmp.id ? { ...m, _tmp: false, _sent: true } : m))), 0);
    } catch (err) {
      setMessages(p => p.map(m => (m.id === tmp.id ? { ...m, _failed: true } : m)));
      setToast(err.response?.data?.error || 'Gönderilemedi');
    }
    setSending(false);
    inputRef.current?.focus();
  }
  async function sendFile(e) {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file || !selectedUser) return;
    const fd = new FormData();
    fd.append('file', file);
    setToast('Dosya gönderiliyor…');
    try {
      const r = await fetch(`/api/chat/${selectedBot.id}/${selectedUser.telegram_id}/media`, { method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, body: fd });
      if (!r.ok) throw new Error(r.statusText);
      setToast('Dosya gönderildi');
    } catch (err) { setToast('Dosya gönderilemedi'); }
  }
  function applyQuickReply(qr) {
    setNewMsg(qr.content); setShowQR(false);
    api.patch(`/chat/quick-replies/${qr.id}/use`).catch(() => {});
    setTimeout(() => inputRef.current?.focus(), 0);
  }
  async function addNote() {
    if (!newNote.trim()) return;
    try { await api.post(`/chat/notes/${selectedBot.id}/${selectedUser.telegram_id}`, { note: newNote, color: noteColor }); setNewNote(''); loadNotes(); } catch (e) { setToast('Not eklenemedi'); }
  }
  async function deleteNote(id) { try { await api.delete(`/chat/notes/${id}`); loadNotes(); } catch (e) { /* noop */ } }
  async function addTag(tagText) {
    const tag = (tagText ?? newTag).trim();
    if (!tag) return;
    try {
      await api.post(`/chat/tags/${selectedBot.id}/${selectedUser.telegram_id}`, { tag, color: tagColor });
      setNewTag('');
      setConversations(prev => prev.map(c => (c.telegram_id !== selectedUser.telegram_id ? c : { ...c, tags: [...(c.tags || []).filter(t => t.tag !== tag), { tag, color: tagColor }] })));
    } catch (e) { setToast('Etiket eklenemedi'); }
  }
  async function removeTag(tag) {
    try {
      await api.delete(`/chat/tags/${selectedBot.id}/${selectedUser.telegram_id}/${encodeURIComponent(tag)}`);
      setConversations(prev => prev.map(c => (c.telegram_id !== selectedUser.telegram_id ? c : { ...c, tags: (c.tags || []).filter(t => t.tag !== tag) })));
    } catch (e) { /* noop */ }
  }
  async function saveQuickReply() {
    if (!newQR.title || !newQR.content) return;
    try { await api.post('/chat/quick-replies', newQR); setNewQR({ title: '', content: '', shortcut: '', category: 'genel' }); loadQuickReplies(); } catch (e) { /* noop */ }
  }
  function openConv(conv) {
    if (selectedUser?.telegram_id === conv.telegram_id) return;
    setSelectedUser(conv); setMessages([]); setNotes([]); setShowQR(false);
    setTimeout(() => inputRef.current?.focus(), 50);
  }
  function switchBot(b) {
    if (!b || b.id === selectedBot?.id) return;
    lsSet(LS_BOT, String(b.id));
    setSelectedBot(b); setSelectedUser(null); setMessages([]); setConversations([]); setInfo(false); setShowQR(false);
  }
  switchRef.current = dir => {
    if (bots.length < 2) return;
    const i = bots.findIndex(b => b.id === selectedBot?.id);
    switchBot(bots[(i + dir + bots.length) % bots.length]);
  };

  /* ── derived ── */
  const sections = useMemo(() => {
    const out = [];
    let cur = null;
    for (const m of messages) {
      const day = new Date(m.created_at).toDateString();
      if (!cur || cur.day !== day) { cur = { day, at: m.created_at, items: [] }; out.push(cur); }
      cur.items.push(m);
    }
    return out;
  }, [messages]);
  const filteredQR = quickReplies.filter(qr => !qrSearch || qr.title?.toLowerCase().includes(qrSearch.toLowerCase()) || qr.content?.toLowerCase().includes(qrSearch.toLowerCase()) || qr.shortcut?.includes(qrSearch));
  const selConv = conversations.find(c => c.telegram_id === selectedUser?.telegram_id) || selectedUser;
  const unreadTotal = conversations.reduce((s, c) => s + (parseInt(c.unread_count, 10) || 0), 0);
  const unreadMap = selectedBot && !search && filter === 'all' && !convLoading ? { ...botUnread, [selectedBot.id]: unreadTotal } : botUnread;
  const syncKey = selectedBot && !search && filter === 'all' && !convLoading ? selectedBot.id + ':' + unreadTotal : '';
  useEffect(() => {
    if (!syncKey) return;
    const [id, n] = syncKey.split(':');
    setBotUnread(p => (p[id] === Number(n) ? p : { ...p, [id]: Number(n) }));
  }, [syncKey]);
  const uName = selectedUser?.full_name || 'Kullanıcı';

  return (
    <div className={'lc' + (selectedUser ? ' has-sel' : '')}>
      <style>{CSS}</style>

      {/* ═══ En sol: bot rayı (masaüstü) ═══ */}
      {bots.length > 1 && (
        <div className="lc-rail">
          {bots.map(b => {
            const on = selectedBot?.id === b.id;
            const u = on ? 0 : (unreadMap[b.id] || 0);
            return (
              <button key={b.id} className={'lc-rb' + (on ? ' on' : '')} onClick={() => switchBot(b)} title={b.name + (u ? ` · ${u} okunmamış` : '')}>
                <span className="av"><Avatar id={b.id} name={b.name} size={44}>{b.bot_type === 'date' ? <Ic n="heart" s={20} /> : null}</Avatar></span>
                {u > 0 && <span className="bdg">{u > 99 ? '99+' : u}</span>}
                <span className="nm">{b.name}</span>
              </button>
            );
          })}
        </div>
      )}

      {/* ═══ Sol: konuşmalar ═══ */}
      <div className="lc-list">
        {bots.length > 1 && (
          <div className="lc-bsw">
            <BotSwitcher bots={bots} selected={selectedBot} onSelect={switchBot} unread={unreadMap}
              sub={`${conversations.length} konuşma${unreadTotal ? ` · ${unreadTotal} okunmamış` : ''}`} />
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 8px 6px 10px' }}>
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, background: 'var(--surface3)', borderRadius: 22, padding: '0 12px', height: 40 }}>
            <Ic n="search" s={18} c="var(--text3)" />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Ara"
              style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: 'var(--text)', fontSize: 15, minWidth: 0, fontFamily: 'inherit' }} />
            {search && <button className="lc-ib" style={{ padding: 2 }} onClick={() => setSearch('')}><Ic n="close" s={16} /></button>}
          </div>
          <button className="lc-ib" title="Hızlı cevaplar" onClick={() => setShowQRManager(true)}><Ic n="bolt" /></button>
        </div>

        <div style={{ display: 'flex', gap: 6, padding: '8px 12px 6px', alignItems: 'center' }}>
          {[['all', 'Tümü'], ['unread', 'Okunmamış']].map(([v, l]) => (
            <button key={v} onClick={() => setFilter(v)} style={{ border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, padding: '5px 12px', borderRadius: 16, background: filter === v ? 'var(--active)' : 'var(--surface3)', color: filter === v ? '#fff' : 'var(--text3)' }}>
              {l}{v === 'unread' && unreadTotal > 0 ? ` · ${unreadTotal}` : ''}
            </button>
          ))}
          {selectedBot && <span className="lc-cur truncate" style={{ marginLeft: 'auto', fontSize: 12.5, color: 'var(--text3)', fontWeight: 600, minWidth: 0 }}>{selectedBot.name}</span>}
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '2px 0 8px' }}>
          {convLoading && !conversations.length && <div style={{ display: 'flex', justifyContent: 'center', padding: 30 }}><Spinner /></div>}
          {!convLoading && !conversations.length && (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--text3)', fontSize: 14 }}>{filter === 'unread' ? 'Okunmamış mesaj yok' : search ? 'Sonuç yok' : 'Henüz konuşma yok'}</div>
          )}
          {conversations.map(c => {
            const act = selectedUser?.telegram_id === c.telegram_id;
            const unread = parseInt(c.unread_count, 10) || 0;
            return (
              <div key={c.telegram_id} className={'lc-row' + (act ? ' act' : '')} onClick={() => openConv(c)}>
                <Avatar id={c.telegram_id} name={c.full_name} size={54} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ flex: 1, fontWeight: 600, fontSize: 15, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.full_name || 'Kullanıcı'}</span>
                    <span style={{ fontSize: 12.5, color: act ? '#cfe0f1' : 'var(--text3)', flexShrink: 0, display: 'flex', alignItems: 'center', gap: 3 }}>
                      {c.last_direction === 'out' && <Ic n="check" s={14} c={act ? '#fff' : 'var(--link)'} sw={2.2} />}
                      {listTime(c.last_time)}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
                    <span style={{ flex: 1, fontSize: 14, color: act ? '#d9e6f2' : 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {c.last_direction === 'out' && <span style={{ color: act ? '#fff' : '#e3e9ef' }}>Siz: </span>}
                      {c.last_type && c.last_type !== 'text' ? <span style={{ color: act ? '#fff' : 'var(--link)' }}>{typeLabel(c.last_type)}</span> : (c.last_message || '').replace(/\s+/g, ' ')}
                    </span>
                    {unread > 0 && <span style={{ background: act ? '#fff' : 'var(--accent)', color: act ? 'var(--active)' : '#fff', fontSize: 12, fontWeight: 600, borderRadius: 11, minWidth: 22, height: 22, lineHeight: '22px', textAlign: 'center', padding: '0 7px', flexShrink: 0 }}>{unread > 99 ? '99+' : unread}</span>}
                  </div>
                  {(c.tags?.length > 0 || c.pinned_note) && (
                    <div style={{ display: 'flex', gap: 4, marginTop: 4, overflow: 'hidden' }}>
                      {(c.tags || []).slice(0, 3).map((t, i) => <span key={i} className="lc-chip" style={{ fontSize: 11, padding: '0 7px', background: act ? 'rgba(255,255,255,.18)' : t.color + '22', color: act ? '#fff' : t.color }}>{t.tag}</span>)}
                      {c.pinned_note && <Ic n="note" s={14} c={act ? '#fff' : 'var(--text3)'} />}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ padding: '8px 14px', borderTop: '1px solid #0a1119', fontSize: 12.5, color: 'var(--text3)', display: 'flex', justifyContent: 'space-between' }}>
          <span>{conversations.length} konuşma</span><span>{unreadTotal} okunmamış</span>
        </div>
      </div>

      {/* ═══ Orta: sohbet ═══ */}
      <div className="lc-main">
        {!selectedUser ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span className="lc-pill" style={{ fontSize: 14, padding: '6px 14px' }}>Mesajlaşmak için bir konuşma seçin</span>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 8px 0 10px', height: 56, background: 'var(--surface)', borderBottom: '1px solid #0a1119', flexShrink: 0 }}>
              <button className="lc-ib lc-back" onClick={() => setSelectedUser(null)} title="Geri"><Ic n="back" /></button>
              <div onClick={() => setInfo(v => !v)} style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 0, cursor: 'pointer' }}>
                <Avatar id={selectedUser.telegram_id} name={uName} size={42} />
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 15.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{uName}</div>
                  <div style={{ fontSize: 13, color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {selectedUser.username ? '@' + selectedUser.username + ' · ' : ''}{selectedBot?.name}
                  </div>
                </div>
              </div>
              <a className="lc-ib" href={`https://t.me/${selectedUser.username || ''}`} target="_blank" rel="noreferrer" title="Telegram'da aç" style={selectedUser.username ? undefined : { display: 'none' }}><Ic n="external" /></a>
              <button className={'lc-ib' + (info ? ' on' : '')} onClick={() => setInfo(v => !v)} title="Detay"><Ic n="info" /></button>
            </div>

            <div ref={listRef} onScroll={e => { const el = e.currentTarget; atBottom.current = el.scrollHeight - el.scrollTop - el.clientHeight < 120; }}
              style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
              <div style={{ maxWidth: 780, margin: '0 auto', padding: '8px 14px 10px', minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                {loading && !messages.length && <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><Spinner /></div>}
                {!loading && !messages.length && <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><span className="lc-pill">Henüz mesaj yok</span></div>}
                {sections.map(sec => (
                  <div key={sec.day}>
                    <div style={{ position: 'sticky', top: 6, zIndex: 3, display: 'flex', justifyContent: 'center', padding: '6px 0', pointerEvents: 'none' }}><span className="lc-pill">{dayLabel(sec.at)}</span></div>
                    {sec.items.map((m, i) => {
                      const out = m.direction === 'out';
                      const next = sec.items[i + 1];
                      const prev = sec.items[i - 1];
                      const last = !next || next.direction !== m.direction;
                      const first = !prev || prev.direction !== m.direction;
                      const bg = out ? '#2b5278' : '#182533';
                      const isMedia = m.media_path && (m.type === 'photo' || m.type === 'gif' || m.type === 'video');
                      return (
                        <div key={m.id} style={{ display: 'flex', justifyContent: out ? 'flex-end' : 'flex-start', padding: `${first ? 5 : 1}px 0 ${last ? 3 : 1}px` }}>
                          <div style={{ position: 'relative', maxWidth: 'min(480px, 82%)' }}>
                            {last && !isMedia && (
                              <svg width="9" height="17" viewBox="0 0 9 17" style={{ position: 'absolute', bottom: 0, [out ? 'right' : 'left']: -8 }}>
                                <path d={out ? 'M6 17H0V0c.19 2.84.88 5.77 2.05 8.78.9 2.33 2.45 4.49 4.62 6.48A1 1 0 0 1 6 17z' : 'M3 17h6V0c-.19 2.84-.88 5.77-2.05 8.78-.9 2.33-2.45 4.49-4.62 6.48A1 1 0 0 0 3 17z'} fill={bg} />
                              </svg>
                            )}
                            <div style={{ background: bg, borderRadius: out ? `15px ${first ? 15 : 6}px ${last && !isMedia ? 0 : 6}px 15px` : `${first ? 15 : 6}px 15px 15px ${last && !isMedia ? 0 : 6}px`, overflow: 'hidden', boxShadow: '0 1px 2px rgba(0,0,0,.18)' }}>
                              {m.media_path && (m.type === 'photo' || m.type === 'gif') && (
                                <img src={mediaUrl(m.media_path)} alt="" loading="lazy" onLoad={stickBottom} onClick={() => setLightbox(mediaUrl(m.media_path))} style={{ display: 'block', maxWidth: '100%', width: 320, maxHeight: 360, objectFit: 'cover', cursor: 'zoom-in', background: '#0f1923' }} />
                              )}
                              {m.media_path && m.type === 'video' && <video src={mediaUrl(m.media_path)} controls preload="metadata" style={{ display: 'block', width: 320, maxWidth: '100%', maxHeight: 360, background: '#000' }} />}
                              {m.media_path && !['photo', 'gif', 'video'].includes(m.type) && (
                                <a href={mediaUrl(m.media_path)} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '8px 11px 2px', color: 'inherit', textDecoration: 'none' }}>
                                  <span style={{ width: 44, height: 44, borderRadius: '50%', background: out ? '#fff' : 'var(--accent)', color: out ? '#2b5278' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ic n="file" s={20} /></span>
                                  <span style={{ minWidth: 0 }}>
                                    <span style={{ display: 'block', fontWeight: 600, fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{(m.type === 'file' ? m.content : null) || typeLabel(m.type) || 'Dosya'}</span>
                                    <span style={{ fontSize: 12.5, color: out ? '#7da8d3' : 'var(--text3)' }}>Aç / indir</span>
                                  </span>
                                </a>
                              )}
                              <div style={{ padding: '6px 10px 6px 11px', position: 'relative' }}>
                                {m.content && m.type !== 'file' && (
                                  <span style={{ fontSize: 14.5, lineHeight: 1.42, whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#f5f5f5' }}>{m.content}</span>
                                )}
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, float: 'right', margin: '6px 0 -3px 10px', fontSize: 12, color: out ? '#7da8d3' : '#6d7f8f', whiteSpace: 'nowrap' }}>
                                  {hhmm(m.created_at)}
                                  {out && (m._failed ? <Ic n="info" s={14} c="var(--danger)" /> : m._tmp ? <Ic n="clock" s={13} /> : (
                                    <svg width="20" height="14" viewBox="0 0 20 16" fill="none" stroke="#8fd0ff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M1.5 8.5l3.5 3.5 7-8" /><path d="M8.5 11.5l.5.5 7-8" /></svg>
                                  ))}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>

            {showQR && (
              <div style={{ position: 'absolute', left: 10, right: 10, bottom: 64, maxWidth: 520, background: 'var(--menu, #1f2936)', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,.5)', zIndex: 20, overflow: 'hidden' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', borderBottom: '1px solid #0a1119' }}>
                  <Ic n="bolt" s={18} c="var(--link)" />
                  <input autoFocus value={qrSearch} onChange={e => setQrSearch(e.target.value)} placeholder="Hızlı cevap ara" onKeyDown={e => e.key === 'Escape' && setShowQR(false)}
                    style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: 'var(--text)', fontSize: 14, fontFamily: 'inherit' }} />
                  <button className="lc-ib" style={{ padding: 4 }} onClick={() => setShowQR(false)}><Ic n="close" s={16} /></button>
                </div>
                <div style={{ maxHeight: 260, overflowY: 'auto', padding: 4 }}>
                  {filteredQR.map(qr => (
                    <div key={qr.id} className="lc-mi" onClick={() => applyQuickReply(qr)}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                        <span style={{ fontWeight: 600, fontSize: 14 }}>{qr.title}</span>
                        {qr.shortcut && <code>{qr.shortcut}</code>}
                      </div>
                      <div style={{ fontSize: 13, color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{qr.content}</div>
                    </div>
                  ))}
                  {!filteredQR.length && <div style={{ padding: 14, fontSize: 13.5, color: 'var(--text3)' }}>Bulunamadı</div>}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 2, padding: '7px 8px', paddingBottom: 'max(7px, env(safe-area-inset-bottom))', background: 'var(--surface)', borderTop: '1px solid #0a1119', flexShrink: 0 }}>
              <input ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={sendFile} />
              <button className="lc-ib" title="Dosya gönder" onClick={() => fileInputRef.current?.click()}><Ic n="attach" s={24} /></button>
              <button className={'lc-ib' + (showQR ? ' on' : '')} title="Hızlı cevap" onClick={() => { setQrSearch(''); setShowQR(v => !v); }}><Ic n="bolt" s={23} /></button>
              <textarea ref={inputRef} rows={1} value={newMsg} placeholder="Mesaj yazın…"
                onChange={e => {
                  setNewMsg(e.target.value);
                  e.target.style.height = 'auto';
                  e.target.style.height = Math.min(e.target.scrollHeight, 160) + 'px';
                  if (e.target.value.startsWith('/') && e.target.value.length > 1) { setQrSearch(e.target.value.substring(1)); setShowQR(true); }
                }}
                onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } if (e.key === 'Escape') setShowQR(false); }}
                style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: 'var(--text)', fontSize: 15, lineHeight: '22px', resize: 'none', height: 22, maxHeight: 160, padding: 0, margin: '9px 6px', fontFamily: 'inherit', overflowY: 'auto' }} />
              <button className="lc-ib" title="Gönder" onClick={sendMessage} disabled={!newMsg.trim() || sending} style={{ color: newMsg.trim() ? 'var(--link)' : 'var(--text3)' }}><Ic n="send" s={26} /></button>
            </div>
          </>
        )}
        {toast && <div style={{ position: 'absolute', left: '50%', bottom: 80, transform: 'translateX(-50%)', background: 'rgba(0,0,0,.8)', color: '#fff', padding: '9px 16px', borderRadius: 10, fontSize: 14, zIndex: 50, pointerEvents: 'none' }}>{toast}</div>}
      </div>

      {/* ═══ Sağ: detay ═══ */}
      {selectedUser && info && (
        <div className="lc-info">
          <div style={{ display: 'flex', alignItems: 'center', height: 56, padding: '0 8px 0 16px', borderBottom: '1px solid #0a1119', flexShrink: 0 }}>
            <div style={{ flex: 1, fontWeight: 600, fontSize: 16 }}>Kullanıcı bilgisi</div>
            <button className="lc-ib" onClick={() => setInfo(false)}><Ic n="close" /></button>
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '22px 16px 14px', textAlign: 'center' }}>
              <Avatar id={selectedUser.telegram_id} name={uName} size={100} />
              <div style={{ fontSize: 19, fontWeight: 600, marginTop: 12 }}>{uName}</div>
              {selectedUser.username && <div style={{ color: 'var(--link)', fontSize: 14 }}>@{selectedUser.username}</div>}
              <div style={{ fontSize: 13, color: 'var(--text3)', marginTop: 2 }}>ID: {selectedUser.telegram_id}</div>
            </div>
            {selectedUser.level != null && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, padding: '0 14px 14px' }}>
                {[['Seviye', 'L' + selectedUser.level, '#a695e7'], ['XP', selectedUser.xp ?? 0, '#e5a443']].map(([l, v, c]) => (
                  <div key={l} style={{ background: 'var(--surface3)', borderRadius: 10, padding: '10px 12px' }}>
                    <div style={{ fontSize: 18, fontWeight: 700, color: c }}>{v}</div>
                    <div style={{ fontSize: 12, color: 'var(--text3)' }}>{l}</div>
                  </div>
                ))}
              </div>
            )}
            <div style={{ height: 8, background: '#0e1621' }} />

            <div style={{ padding: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 600, color: 'var(--link)', marginBottom: 10 }}><Ic n="tag" s={18} />Etiketler</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                {(selConv?.tags || []).map((t, i) => (
                  <span key={i} className="lc-chip" onClick={() => removeTag(t.tag)} title="Kaldır" style={{ background: t.color + '22', color: t.color, cursor: 'pointer' }}>{t.tag}<Ic n="close" s={12} /></span>
                ))}
                {!(selConv?.tags || []).length && <span style={{ fontSize: 13, color: 'var(--text3)' }}>Etiket yok</span>}
              </div>
              <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
                <input className="input" value={newTag} onChange={e => setNewTag(e.target.value)} placeholder="Yeni etiket" onKeyDown={e => e.key === 'Enter' && addTag()} />
                <button className="btn btn-primary" style={{ borderRadius: 8, width: 42, padding: 0 }} onClick={() => addTag()}><Ic n="plus" s={18} /></button>
              </div>
              <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
                {TAG_COLORS.map(c => <span key={c} className={'lc-sw' + (tagColor === c ? ' on' : '')} style={{ background: c }} onClick={() => setTagColor(c)} />)}
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                {TAG_PRESETS.map(t => <button key={t} className="btn btn-xs btn-ghost" onClick={() => addTag(t)}>{t}</button>)}
              </div>
            </div>
            <div style={{ height: 8, background: '#0e1621' }} />

            <div style={{ padding: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 600, color: 'var(--link)', marginBottom: 10 }}><Ic n="note" s={18} />Notlar</div>
              <textarea className="input" value={newNote} onChange={e => setNewNote(e.target.value)} placeholder="Bu kullanıcı için not…" style={{ minHeight: 64, resize: 'none' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '8px 0 10px' }}>
                {NOTE_COLORS.map(c => <span key={c} className={'lc-sw' + (noteColor === c ? ' on' : '')} style={{ background: c }} onClick={() => setNoteColor(c)} />)}
                <button className="btn btn-sm btn-primary" style={{ marginLeft: 'auto' }} onClick={addNote} disabled={!newNote.trim()}>Ekle</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {notes.map(n => (
                  <div key={n.id} style={{ background: (n.color || '#e5a443') + '18', borderLeft: `3px solid ${n.color || '#e5a443'}`, borderRadius: '4px 10px 10px 4px', padding: '8px 30px 8px 10px', position: 'relative' }}>
                    <div style={{ fontSize: 14, lineHeight: 1.45, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{n.note}</div>
                    <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4 }}>{n.admin_username} · {new Date(n.created_at).toLocaleDateString('tr-TR')}</div>
                    <button className="lc-ib" style={{ position: 'absolute', top: 2, right: 2, padding: 5 }} onClick={() => deleteNote(n.id)}><Ic n="close" s={14} /></button>
                  </div>
                ))}
                {!notes.length && <div style={{ fontSize: 13, color: 'var(--text3)' }}>Not yok</div>}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hızlı cevap yöneticisi */}
      {showQRManager && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowQRManager(false)}>
          <div className="modal" style={{ maxWidth: 560, width: '100%' }}>
            <h3 style={{ display: 'flex', alignItems: 'center', gap: 8 }}><Ic n="bolt" s={20} c="var(--link)" />Hızlı cevaplar</h3>
            <div className="grid-2" style={{ gap: 10, gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 200px), 1fr))' }}>
              <div className="input-group" style={{ marginBottom: 0 }}><label>Başlık</label><input className="input" value={newQR.title} onChange={e => setNewQR({ ...newQR, title: e.target.value })} placeholder="Karşılama" /></div>
              <div className="input-group" style={{ marginBottom: 0 }}><label>Kısayol</label><input className="input" value={newQR.shortcut} onChange={e => setNewQR({ ...newQR, shortcut: e.target.value })} placeholder="/mrb" /></div>
            </div>
            <div className="input-group" style={{ marginTop: 12 }}><label>İçerik</label><textarea className="input" value={newQR.content} onChange={e => setNewQR({ ...newQR, content: e.target.value })} placeholder="Merhaba! Size nasıl yardımcı olabilirim?" style={{ minHeight: 70 }} /></div>
            <button className="btn btn-primary btn-sm" onClick={saveQuickReply} disabled={!newQR.title || !newQR.content} style={{ marginBottom: 14 }}><Ic n="plus" s={16} />Ekle</button>
            <div style={{ maxHeight: 300, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
              {quickReplies.map(qr => (
                <div key={qr.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '9px 11px', background: 'var(--surface3)', borderRadius: 10 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 2 }}>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{qr.title}</span>
                      {qr.shortcut && <code>{qr.shortcut}</code>}
                      <span style={{ fontSize: 12, color: 'var(--text3)' }}>{qr.use_count || 0}× kullanıldı</span>
                    </div>
                    <div style={{ fontSize: 13, color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{qr.content}</div>
                  </div>
                  <button className="btn btn-danger btn-sm" onClick={() => api.delete(`/chat/quick-replies/${qr.id}`).then(loadQuickReplies)}><Ic n="trash" s={15} /></button>
                </div>
              ))}
              {!quickReplies.length && <div className="text-muted text-sm">Henüz hızlı cevap yok</div>}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}><button className="btn btn-ghost" onClick={() => setShowQRManager(false)}>Kapat</button></div>
          </div>
        </div>
      )}

      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.92)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out' }}>
          <img src={lightbox} alt="" style={{ maxWidth: '94vw', maxHeight: '90vh', objectFit: 'contain' }} />
        </div>
      )}
      <style>{'.lc-back { display:none !important; } @media (max-width: 900px) { .lc-back { display:inline-flex !important; } .lc-cur { display:none; } }'}</style>
    </div>
  );
}
